/*
    Create by fanglijuan 2019-04-29
    转移至
*/
"use strict";
angular.module("appQuickSignMoveToModule", [])
    .controller("appQuickSignMoveToCtrl", ['$scope', '$q', '$state', '$modalInstance', '$timeout', 'trsHttpService', "trsspliceString", "modalDialog", "objData", "editingCenterService", "trsGroupTreeLocationService",
        function($scope, $q, $state, $modalInstance, $timeout, trsHttpService, trsspliceString, modalDialog, objData, editingCenterService, trsGroupTreeLocationService) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = objData;
                $scope.treeOptions = {
                    nodeChildren: "CHILDREN",
                    dirSelectable: true,
                    injectClasses: {
                        ul: "a1",
                        li: "a2",
                        liSelected: "a7",
                        iExpanded: "a3",
                        iCollapsed: "a4",
                        iLeaf: "a5",
                        label: "a6",
                        labelSelected: "a8"
                    },
                    isLeaf: function(node) {
                        return node.HASCHILDREN == "false";
                    }
                };
                $scope.searchWord = '';
                $scope.expandedTest = [];
                $scope.selectedUser = {};
            }

            function initData() {
                getTreeList();
            }
            /**
             * [getTreeList 获取组织树]
             * @return {[type]} [description]
             */
            function getTreeList() {
                var params = {
                    "serviceid": "mlf_group",
                    "methodname": "queryGroupTreeWithMyPath"
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.treedata = [data];
                    trsGroupTreeLocationService.getGroupIdsPath($scope.treedata[0].GROUPID).then(function(data) {
                        data.splice(0, 1);
                        trsGroupTreeLocationService.groupTreeLocation(data, $scope.treedata[0], $scope.selectedNode, $scope.expandedTest, function(tree, array, selectedNode) {
                            $scope.treedata = [tree];
                            $scope.expandedTest.push($scope.treedata[0]);
                            $scope.selectedNode = selectedNode;
                            $scope.showSelected($scope.selectedNode);
                        });
                    });
                    ExpandedNodes();

                }, function(data) {});
            }
            //默认展开树开始
            function ExpandedNodes() {
                $scope.expandedTest = [];
                $scope.expandedTest.push($scope.treedata[0]);
                if ($scope.treedata[0].CHILDREN === 0) {
                    $scope.selectedNode = $scope.treedata[0];
                    getGroupData($scope.selectedNode);
                } else {
                    angular.forEach($scope.treedata[0].CHILDREN, function(data, index, array) {
                        if (data.ISPATH === "true") {
                            $scope.expanded.push(data);
                            if (data.CHILDREN.length !== 0) {
                                selfPath(data);
                            } else {
                                $scope.selectedNode = data;
                                getGroupData($scope.selectedNode);
                            }

                        }
                    });
                }
            }
            //默认展开树结束
            function getGroupData(node) {
                $timeout(function() {
                        //此判断如果两次点击同一个树，不重复加载角色列表。
                        $scope.groupObj = node;
                        $scope.oldSelectNode = node;
                        $scope.Datas = [];
                        $scope.users = null;
                        var params = {
                            "serviceid": "mlf_group",
                            "methodname": "getUsersByGroup",
                            "GroupId": $scope.groupObj.GROUPID
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                            $scope.users = data;
                        }, function(data) {
                            modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                        });
                    },
                    100);
            }
            /**
             * [showToggle 展开子节点]
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */
            $scope.showToggle = function(node) {
                childrenTree(node, function() {});
            };
            /**
             * [chooseUser 选择用户]
             * @param  {[type]} user [description]
             * @return {[type]}      [description]
             */
            $scope.chooseUser = function(user) {
                if (angular.isDefined(user.selected) && user.selected === "selected") {
                    $scope.selectedUser = {};
                    user.selected = "";
                } else {
                    if (angular.isDefined($scope.oldUser)) {
                        $scope.oldUser.selected = "";
                    }
                    $scope.selectedUser = user;
                    user.selected = "selected";
                    $scope.oldUser = user;
                }
            };



            /**
             * [getSuggestions input输入]
             * @param  {[type]} viewValue [description]
             * @return {[type]}           [description]
             */
            $scope.getSuggestions = function(viewValue) {
                if (viewValue !== '') {
                    var searchUsers = {
                        serviceid: "mlf_extuser",
                        methodname: "searchUserOrDept",
                        Name: viewValue
                    };
                    if ($scope.isRequest) {
                        $scope.isRequest = false;
                        return [];
                    } else {
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, "post").then(function(data) {
                            return data;
                        });
                    }
                }
            };

            $scope.$watch('searchWord', function(newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    $scope.isRequest = true;
                    $scope.users = [newValue];
                    $scope.searchWord = newValue.USERNAME;
                }
            });


            function selfPath(data) {
                for (var i = 0; i < data.CHILDREN.length; i++) {
                    if (data.CHILDREN[i].ISPATH === "true") {
                        if (data.CHILDREN[i].HASCHILDREN === "false" || data.CHILDREN[i].CHILDREN.length === 0) {
                            $scope.selectedNode = data.CHILDREN[i];
                            getGroupData($scope.selectedNode);
                            break;
                        } else {
                            $scope.expandedTest.push(data.CHILDREN[i]);
                            selfPath(data.CHILDREN[i]);
                            break;
                        }
                    }
                }
            }

            /**
             * [childrenTree 子节点方法]
             * @param  {[type]}   node     [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function childrenTree(node, callback) {
                if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
                    var paramsT = {
                        "serviceid": "mlf_group",
                        "methodname": "queryChildGroupsWithOutRight",
                        "GroupId": node.GROUPID
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, "get").then(function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    }, function(dataC) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
                }
            }

            $scope.showSelected = function(node) {
                getGroupData(node);
                $scope.currUser = "";
            };
            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {

                if (JSON.stringify($scope.selectedUser) === '{}') {
                    modalDialog.alertType("提示信息", "请选择用户", "warning", false, function() {});
                } else {
                    var params = {
                        "serviceid": "mlf_appquickpublish",
                        "methodname": "moveRels",
                        "ObjectIds": trsspliceString.spliceString($scope.status.array, 'QUICKPUBCHANNELCATEGORYRELID', ','),
                        "SITEID": $scope.status.SITEID,
                        "acceptUser": $scope.selectedUser.ID
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $modalInstance.close(data);
                    }, function() {
                        $modalInstance.close('success');
                    });
                }
            };
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);